import {
  Directive, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewContainerRef
} from "@angular/core";
import {
  AuthService
} from "../services/auth.service";
import { ClaimTypeAndValue } from "../../services/api.service";


@Directive({
  selector: '[requireClaims]',
  standalone: true,
})
export class RequireClaimsDirective implements OnInit {

  @Output() requireFailed = new EventEmitter<{
    sender: any
    requirement: ClaimTypeAndValue | ClaimTypeAndValue[],
    errors: string[]
  }>()
  protected _requirement?: ClaimTypeAndValue | ClaimTypeAndValue[]
  protected _errors: string[] = []

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {
  }

  get requirements(): ClaimTypeAndValue[] {
    if (!this._requirement) return []
    if (Array.isArray(this._requirement)) return this._requirement
    return [this._requirement]
  }

  ngOnInit() {
  }

  @Input()
  set requireClaims(requirement: ClaimTypeAndValue | ClaimTypeAndValue[]) {
    this._requirement = requirement
    this.updateView();
  }

  protected updateView() {
    if (this.checkPermission()) {
        this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
      this.requireFailed.emit({
        sender: this,
        requirement: this.requirements,
        errors: this._errors
      })
    }
  }

  protected checkPermission() {
    const re = this.requirements
    this._errors = []
    for (let idx = 0; idx < re.length; idx++ ) {
      const r = re[idx]
      if (!this.authService.hasClaim(r.type, r.value)) {
        console.warn('Claim validation failure', r)
        this._errors.push(`Expected claim [${r.type}] with value [${r.value}] not matched.`)
        return false
      }
    }
    console.debug('Claim validation ok', this.requirements)
    return true
  }
}
